import React, { useCallback, useEffect, useState } from 'react';
import pt from 'prop-types';
import InfiniteGrid from '../infiniteGrid';
import {
  getFiltersFromQueryParams,
  getMappedFilterDates,
} from '../../../../../helpers/filters';
import { getIfDesignAwardBadge } from '../../../../../helpers/badges';

import { getAPIRoot } from '../../../../../helpers/fetch';
import { API_ROUTES } from '../../../../../utils/constants';

const DEFAULT_FILTERS = {
  awards: [],
  categories: [],
  countries: [],
  disciplines: [],
  find: '',
  isBestOfTheYear: false,
  isGoldAward: false,
  isSupportedByIf: false,
  profileId: 0,
  sipTalentCategories: [],
  sort: 'desc',
  tag: '',
  years: [],
};

const QUERY_PARAM_MAPPING = {
  awardId: 'awards',
  disciplineId: 'disciplines',
  categoryId: 'categories',
  countryId: 'countries',
  yearId: 'range',
  regionId: 'countries',
  profile: 'profileId',
};

const GOLD_AWARD_MOCK_ID = 9999;
const SUPPORTED_BY_IF_MOCK_ID = 8888;
const BEST_OF_THE_YEAR_MOCK_ID = 7777;

const InfiniteProjects = ({ setTotal, filtersAsQueryString, limit }) => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  const filters = getFiltersFromQueryParams(
    DEFAULT_FILTERS,
    filtersAsQueryString,
    QUERY_PARAM_MAPPING
  );

  filters.isSupportedByIf = filters.awards.includes(SUPPORTED_BY_IF_MOCK_ID);
  filters.isGoldAward = filters.awards.includes(GOLD_AWARD_MOCK_ID);
  filters.isBestOfTheYear = filters.awards.includes(BEST_OF_THE_YEAR_MOCK_ID);

  filters.awards = filters.awards.filter(
    (filter) =>
      ![
        SUPPORTED_BY_IF_MOCK_ID,
        GOLD_AWARD_MOCK_ID,
        BEST_OF_THE_YEAR_MOCK_ID,
      ].includes(filter)
  );

  const fetchResults = async () => {
    let apiRoot = await getAPIRoot();

    await fetch(
      `${apiRoot}${API_ROUTES.ENTRIES}/unpaginated/${limit}/${filters.sort}`,
      {
        method: 'POST',
        redirect: 'follow',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(filters),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        const data = res.items.map((item) => {
          return {
            image: { url: item.primaryMediaThumbnail, description: item.name },
            title: item.name,
            subline: item.designation,
            info: item?.clients?.[0],
            link: { linkToPage: item.slug },
            awardBadge: getIfDesignAwardBadge(item),
          };
        });
        setLoading(false);
        setResults(data);
        setTotal(res.count);
      });
  };

  useEffect(() => {
    fetchResults();
  }, []);

  return <InfiniteGrid items={results} loading={loading} />;
};

InfiniteProjects.propTypes = {
  setTotal: pt.func,
  filtersAsQueryString: pt.string,
  limit: pt.number,
};

InfiniteProjects.defaultProps = {
  setTotal: () => {},
  filtersAsQueryString: '',
  limit: 150,
};

export default InfiniteProjects;
